function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = React.createElement("defs", null, React.createElement("path", {
  id: "a",
  d: "M0 .018h8.104v1H0z"
}));

var _ref2 = React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(0 27.196)"
}, React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#a"
})), React.createElement("path", {
  d: "M8.104.018H0",
  stroke: "#2E388E",
  strokeWidth: 0.4,
  mask: "url(#b)"
})), React.createElement("path", {
  d: "M21.3 26.88a2.592 2.592 0 1 0 5.184 0 2.592 2.592 0 0 0-5.185 0m9.279 8.801a2.593 2.593 0 1 0 5.187 0 2.593 2.593 0 0 0-5.187 0m8.939-15.557a2.593 2.593 0 1 0 5.186 0 2.593 2.593 0 0 0-5.186 0m11.19 6.686a2.593 2.593 0 1 0 5.187 0 2.593 2.593 0 0 0-5.187 0",
  fill: "#BEFFFC"
}), React.createElement("path", {
  d: "M11.167 27.214c0 14.93 12.102 27.031 27.031 27.031 14.93 0 27.031-12.102 27.031-27.03C65.23 12.284 53.127.182 38.2.182c-14.93 0-27.032 12.102-27.032 27.031z",
  stroke: "#2E388E",
  strokeWidth: 0.4
}), React.createElement("path", {
  d: "M15.762 27.384c.035-.653.099-1.299.188-1.936C17.494 14.551 26.883 6.144 38.199 6.144M16.268 35.23a22.355 22.355 0 0 1-.882-4.85m22.813 20.703c-6.558 0-12.467-2.823-16.578-7.317m33.023 4.927l13.189 13.19.003-.002c.017.017.03.035.048.052a3.688 3.688 0 1 0 5.215-5.216l-.053-.047.003-.002-13.235-13.236M21.793 27.214a2.824 2.824 0 1 0 5.649.001 2.824 2.824 0 0 0-5.649 0zm30.072 0a2.825 2.825 0 1 0 5.65 0 2.825 2.825 0 0 0-5.65 0zm-20.639 8.733a2.825 2.825 0 1 0 5.65 0 2.825 2.825 0 0 0-5.65 0zm8.791-15.414a2.825 2.825 0 1 0 5.65 0 2.825 2.825 0 0 0-5.65 0zm-18.224 6.681H13.69m62.196 0h-8.104m-5.52 0h-4.747M26.55 29.275l4.968 4.967m4.471-.552l5.796-10.542m3.642-1.16l6.568 3.974",
  stroke: "#2E388E",
  strokeWidth: 0.4
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 76 63",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em"
  }, props), _ref, _ref2);
};

export default SvgComponent;


// WEBPACK FOOTER //
// ./src/components/sections/aboutUs/ecoSystem/monitoring.svg